import { Card, Tabs } from 'antd'
import { useState } from 'react'
import PostEventHandson from './PostEventHandson'
import PostEventRecording from './PostEventRecording'
import PostEventViewer from './PostEventViewer'

const tabItems = [
  {
    key: 'Hands-on',
    label: 'Hands-on',
    children: <PostEventHandson />
  },
  {
    key: 'Viewer',
    label: 'Viewer',
    children: <PostEventViewer />
  },
  {
    key: 'Recording',
    label: 'Recording',
    children: <PostEventRecording />
  }
]

const PostEvent = function () {
  const [selectedTab, setSelectedTab] = useState('Hands-on')

  return <Card>
    <Tabs activeKey={selectedTab} items={tabItems} onChange={t => { setSelectedTab(t) }} />
  </Card>
}

export default PostEvent
